import { Dispatch, ThunkAction } from 'app/types/actions';
import { IGetState } from 'app/types/types';
import { loadChatGroup } from 'app/rest/effects/chats/group/loadChatGroup';

export const updateChatGroupsFromResponse = (
    response: any
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        if (!response || !response.headers || !response.headers.get('chatGroups')) return;

        const ids: [] = JSON.parse(response.headers.get('chatGroups'));
        ids.forEach((id) =>{
            return dispatch(loadChatGroup(id, true));
        })

    };
    return action;
};
